// ─── Remuneración vigente para un mes puntual ───────────────────────────────────────────────
//
// Fuente ÚNICA de "qué remuneración aplica en el mes M" (regla 10.1). Resuelve la vigencia
// EFECTIVA del mes pedido, no la de hoy: `inicio_vigencia ≤ último día del mes` y
// `(!fin_vigencia || fin_vigencia ≥ primer día del mes)`. Misma fórmula que ya usa la proyección
// de caja (FlujoCajaV2), extraída acá para que el modal de liquidación y el recibo PDF de
// Empleados dejen de calcular cualquier mes con la vigencia actual (bug Fase A.2).
//
// Devuelve null si el mes NO está cubierto por ninguna vigencia (ej. meses anteriores a la primera
// vigencia del empleado): el consumidor NO debe liquidar ese mes (espejo del `continue` de la caja),
// en vez de inventar una liquidación con la vigencia de hoy.
//
// Las fechas de `remuneraciones_empleado` son strings ISO 'YYYY-MM-DD'; la comparación lexicográfica
// de strings ISO equivale a la comparación de fechas (no se instancian Date para comparar).

/**
 * @param {Array<{inicio_vigencia:string, fin_vigencia:?string}>} remuneraciones - Vigencias de UN
 *        empleado (ya filtradas por empleado_id). Cualquier orden.
 * @param {number} año - Año del período (ej. 2026).
 * @param {number} mes - Mes 1-based (1 = enero … 12 = diciembre).
 * @returns {Object|null} La vigencia efectiva del mes (la de inicio más reciente que lo cubre), o
 *          null si ninguna lo cubre.
 */
export const remuneracionVigenteParaMes = (remuneraciones, año, mes) => {
  if (!Array.isArray(remuneraciones) || remuneraciones.length === 0) return null;
  const mesStr = `${año}-${String(mes).padStart(2, "0")}-01`; // primer día del mes
  const ultimoDiaMes = new Date(año, mes, 0).toISOString().split("T")[0]; // día 0 del mes siguiente
  const vigentes = remuneraciones.filter(
    (r) => r && r.inicio_vigencia <= ultimoDiaMes && (!r.fin_vigencia || r.fin_vigencia >= mesStr)
  );
  // La de inicio de vigencia MÁS RECIENTE que cubre el mes (orden descendente, tomar la primera).
  return vigentes.sort((a, b) => (a.inicio_vigencia < b.inicio_vigencia ? 1 : -1))[0] || null;
};
